module.exports = [{
    "_id": "12eb47e1-59d8-11ec-b6a6-258b33ee8e90",
    "program": {
        "_id": "12eb47e1-59d8-11ec-b6a6-258b33ee8e90",
        "name": "Test APM2",
        "active": 0,
        "idBranch": "933SPOKANE",
        "products": {
            "flyers": {
                "styles": {"187036": "Flyers"},
                "options": {
                    "pdfDownload": 1,
                    "defaultCoating": "none",
                    "flyersFileType": "JPG",
                    "defaultCoatingSide": 3
                },
                "templates": {"sold": "", "openHouse": "", "newListing": "402194", "priceChange": "402194"},
                "quantities": {"sold": "", "openHouse": "", "newListing": "20", "priceChange": "20"}
            },
            "facebook": {
                "styles": [],
                "options": {"defaultUrl": "https://www.xpressdocs.com"},
                "comments": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""},
                "templates": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""}
            },
            "brochures": {
                "styles": {"187037": "Brochures"},
                "options": {
                    "pdfDownload": 1,
                    "defaultCoating": "none",
                    "brochuresFileType": "JPG",
                    "defaultCoatingSide": 3
                },
                "templates": {"sold": "", "openHouse": "", "newListing": "402201", "priceChange": "402201"},
                "quantities": {"sold": "", "openHouse": "", "newListing": "20", "priceChange": "20"}
            },
            "postcards": {
                "styles": {"124304": "Postcards"},
                "options": {
                    "pdfDownload": 1,
                    "defaultCoating": "none",
                    "mailClassDefault": "First Class",
                    "postcardsFileType": "JPG",
                    "defaultCoatingSide": 1
                },
                "comments": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""},
                "templates": {"sold": "", "openHouse": "", "newListing": "402193", "priceChange": "402193"},
                "quantities": {"sold": "", "openHouse": "", "newListing": "20", "priceChange": "20"}
            },
            "socialMedia": {
                "styles": {"187038": "Social Media"},
                "options": {"defaultUrl": "https://www.xpressdocs.com"},
                "templates": {"sold": "", "openHouse": "", "newListing": "402213", "priceChange": ""}
            },
            "imageDownload": {
                "styles": {"187038": "Social Media"},
                "options": {"defaultFileType": "jpg"},
                "templates": {"sold": "", "openHouse": "", "newListing": "402213", "priceChange": "402213"}
            }
        },
        "useAgent": 1,
        "createdAt": "2021-12-10 16:41:50 UTC",
        "createdBy": "Lydia Pape",
        "idCompany": "d2dbadb1",
        "idProgram": "f931db79",
        "updatedAt": "2022-10-29 02:07:02 UTC",
        "useBranch": 1,
        "useCompany": 1,
        "dateCreated": "2021-12-10 10:41:49",
        "eventLabels": {
            "sold": "Sold",
            "openHouse": "Open House",
            "newListing": "New Listing",
            "priceChange": "Price Change"
        },
        "dateModified": "2022-10-28 21:07:01",
        "idProgramType": 13,
        "internalNotes": "",
        "lastModifiedBy": "Hunter Thompson",
        "communicationPrefs": {
            "emailToAgents": {
                "sold": 1,
                "ccAdmin": 0,
                "openHouse": 1,
                "newListing": 1,
                "priceChange": 1
            },
            "suppressEmails": 0,
            "emailToOfficeAdminOnly": {"sold": 0, "openHouse": 0, "newListing": 0, "priceChange": 0}
        },
        "programPreferences": {
            "linkName": "",
            "useCopay": 0,
            "linkActive": 0,
            "subCategoryID": "144063",
            "subCategoryName": "APM2",
            "idBillingAccount": "",
            "includeOrResident": 0,
            "billingAccountName": "",
            "qualityImageWarning": 0,
            "autoNewUserSubscribe": 0,
            "displayProductGeneral": 0,
            "displayProductSidebar": 0,
            "apmMaxListingDaysForNotification": 90
        }
    }
}];


